import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.TEAM_EDIT_SUCCESS, editedTeam: data.team });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.TEAM_EDIT_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const editTeam = (data, teamId) => {
  return async (dispatch) => {
    dispatch({ type: CONST.TEAM_EDIT_REQUEST });

    axios.put(`/teams/${teamId}`, data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
